import * as XLSX from "xlsx";

const useExport = () => {

    const exportToExcel = (rows, headers, sheetName, workbookName) => {
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        /* fix headers */
        XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
        /* calculate column width */
        // const max_width = rows.reduce((w, r) => Math.max(w, r.name.length), 5);
        // worksheet["!cols"] = [ { wch: max_width }, { wch: max_width },  ];
        XLSX.writeFile(workbook, `${workbookName}_${new Date().getTime()}.xlsx`, { compression: true });
    }

    return {
        exportToExcel,
    };

}

export default useExport;